import { render, staticRenderFns } from "./YesNoIcon.vue?vue&type=template&id=40c4c82e&"
import script from "./YesNoIcon.vue?vue&type=script&lang=js&"
export * from "./YesNoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports